import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { SnackBarService } from '../services/snackbar.service';
import bugsnag from 'bugsnag-js';
import { Client } from 'bugsnag-js/types/client';
import { environment } from '../../../environments/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private bugsnagClient: Client;

  constructor(private injector: Injector) {
    this.bugsnagClient = bugsnag('5eff993ee97e1e8f4a5ff2a7604abb64');
  }

  handleError(error) {
    if (error) {
      if (error.status) {
        switch (error.status) {
          case 403:
          case 401:
          case 502:
            return;
        }
      }
    }

    // const snackBarService = this.injector.get(SnackBarService);
    console.error(error);
    if (environment.production) {
      this.bugsnagClient.notify(error);
    }
  }
}
